<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 12 12">
    <g transform="translate(8808 8176)">
      <path d="M11.94,15.787l4.348-4.3a.825.825,0,0,1,1.161,0,.813.813,0,0,1,0,1.151L12.522,17.51a.827.827,0,0,1-1.133.024L6.427,12.639a.811.811,0,0,1,0-1.151.825.825,0,0,1,1.161,0Z" transform="translate(-8813.688 -8184.247)" fill="#7b8190"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconChevronDown',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>